import React, { Fragment, useEffect, useMemo, useState } from 'react';
import Sportspage from './Sportspage';
import Loader from '../layout/loader';

import './sports.css';

function SportsPagePagination({ products, resultPerPages, loading }) {
    const productList = useMemo(() => Array.isArray(products) ? products : [], [products]);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        setCurrentPage(1);
    }, [productList, resultPerPages]);

    const pageCount = useMemo(() => {
        return Math.ceil(productList.length / resultPerPages);
    }, [productList, resultPerPages]);

    const currentItems = useMemo(() => {
        const indexOfLastItem = currentPage * resultPerPages;
        const indexOfFirstItem = indexOfLastItem - resultPerPages;
        return productList.slice(indexOfFirstItem, indexOfLastItem);
    }, [productList, currentPage, resultPerPages]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        const productsEl = document.getElementById("sneakers-products");
        if (productsEl) {
            productsEl.scrollIntoView({ behavior: "smooth" });
        }
    };

    const handlePrevClick = () => {
        if (currentPage > 1) {
            handlePageClick(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        if (currentPage < pageCount) {
            handlePageClick(currentPage + 1);
        }
    };

    return (
        <Fragment>
            {loading ? <Loader /> : (
                <Fragment>
                    <div className="sports-pagenation-shoes-conatiner-div">
                        <Sportspage currentItems={currentItems} />
                    </div>

                    {pageCount > 1 && (
                        <nav className="react-pagenation-container" aria-label="Product pagination">
                            <button
                                type="button"
                                onClick={handlePrevClick}
                                disabled={currentPage === 1}
                                aria-label="Previous page"
                            >
                                Prev
                            </button>
                            {Array.from({ length: pageCount }, (_, i) => {
                                const pageNum = i + 1;
                                return (
                                    <button
                                        key={pageNum}
                                        type="button"
                                        onClick={() => handlePageClick(pageNum)}
                                        className={currentPage === pageNum ? "react-pagenation-active-class-a" : ""}
                                        aria-label={`Page ${pageNum}`}
                                        aria-current={currentPage === pageNum ? "page" : undefined}
                                    >
                                        {pageNum}
                                    </button>
                                );
                            })}
                            <button
                                type="button"
                                onClick={handleNextClick}
                                disabled={currentPage === pageCount}
                                aria-label="Next page"
                            >
                                Next
                            </button>
                        </nav>
                    )}
                </Fragment>
            )}
        </Fragment>
    );
}

export default SportsPagePagination;
